import { render } from "./InfoCircleIcon.vue?vue&type=template&id=91330d44"
import script from "./InfoCircleIcon.vue?vue&type=script&lang=js"
export * from "./InfoCircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__